module.exports = __webpack_public_path__ + "img/default_map_listing_image.bf487f57c416c7da8eedf2c883d9bd14.svg";